import gql from 'graphql-tag';
import taskFragment from '../task';

export default gql`
  fragment taskActivityFragment on TaskActivity {
    id
    taskId
    task {
      ...taskFragment
      user {
        id
        firstName
        lastName
      }
    }
  }
  ${taskFragment}
`;

